import { ParsedFragmentEntity } from '@entities/ParsedFragment/Types';
import {
    ViewItemTypesModeEnum,
    ViewItemTypesModeType,
} from '@modules/Steps/Shared/Enums/ViewItemTypesModeEnum';
import { ItemTypeEntity } from '@entities/ItemType/Types';
import { CostSummaryHeaderStep2 } from '@modules/Steps/Shared/Widgets/CostSummaryHeaderStep2/CostSummaryHeaderStep2';
import { LaborAndToolsItemTypesInfoStep2 } from '@modules/Steps/Components/Step2/LaborAndToolsItemTypesInfoStep2/LaborAndToolsItemTypesInfoStep2';
import css from './Step2MobileContent.module.css';
import { FragmentInfoMobileStep2 } from '@modules/Steps/Components/Step2/Step2MobileContent/FragmentInfoMobileStep2/FragmentInfoMobileStep2';
import React from 'react';

interface Step2MobileContentProps {
    fragments: ParsedFragmentEntity[];
    fragmentsViewMode: ViewItemTypesModeType;
    laborItemTypes: ItemTypeEntity[];
    toolItemTypes: ItemTypeEntity[];
}

const Step2MobileContent: React.FC<Step2MobileContentProps> = ({
    fragments,
    fragmentsViewMode,
    laborItemTypes,
    toolItemTypes,
}) => {
    const filteredFragments = fragments.filter(
        fragment =>
            fragment.itemTypes.length > 0 &&
            fragment.itemTypes.some(itemType => itemType.qty > 0)
    );

    return (
        <div className={css.step2ContentMobile}>
            <CostSummaryHeaderStep2 itemTypesViewMode={fragmentsViewMode} />

            <div className={css.step2ContentMobileFragmentsList}>
                {filteredFragments.map(fragment => (
                    <FragmentInfoMobileStep2
                        key={fragment.uuid}
                        fragment={fragment}
                    />
                ))}

                {fragmentsViewMode ===
                    ViewItemTypesModeEnum.MaterialsLaborTools &&
                    laborItemTypes &&
                    laborItemTypes.length > 0 && (
                        <LaborAndToolsItemTypesInfoStep2
                            title="Labour required for task (optional)"
                            description="Indicative labour costs for each section, not purchasable."
                            itemTypes={laborItemTypes}
                        />
                    )}

                {fragmentsViewMode ===
                    ViewItemTypesModeEnum.MaterialsLaborTools &&
                    toolItemTypes &&
                    toolItemTypes.length > 0 && (
                        <LaborAndToolsItemTypesInfoStep2
                            title="Tools required for task (optional)"
                            description="You can select the tools you require, these are purchasable from the supplier you select."
                            itemTypes={toolItemTypes}
                        />
                    )}
            </div>
        </div>
    );
};

export default React.memo(Step2MobileContent);
